var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9989 16.0005C31.9989 24.0814 26.0088 30.7621 18.2271 31.8462C17.4995 31.9471 16.7551 31.9998 15.9994 31.9998C15.1272 31.9998 14.2707 31.9303 13.4366 31.7958C5.81859 30.5693 0 23.9637 0 16.0005C0 7.16388 7.16393 0 16.0006 0C24.8372 0 32.0011 7.16388 32.0011 16.0005H31.9989Z",
    fill: "#001110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2271 12.8481V16.3337H22.5389L21.8561 21.0289H18.2271V31.8465C17.4995 31.9474 16.7551 32 15.9994 32C15.1272 32 14.2707 31.9305 13.4366 31.796V21.0289H9.45996V16.3337H13.4366V12.069C13.4366 9.42315 15.5813 7.27734 18.2282 7.27734V7.27959C18.2361 7.27959 18.2428 7.27734 18.2506 7.27734H22.54V11.338H19.7372C18.9042 11.338 18.2282 12.014 18.2282 12.847L18.2271 12.8481Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.89fde62f458562dcfdcdae21d1a07c18.svg";
export { ForwardRef as ReactComponent };